export interface FieldModel<T> {
    regex?: string
    valid: boolean
    value: T
    name: string
    label: string
    required: boolean
    touched: boolean
    formatter: string
}

export class FieldModelObject<T> implements FieldModel<T> {
    public regex?: string
    public valid: boolean
    public value: T
    public name: string
    public label: string
    public required: boolean
    public touched: boolean
    public formatter: string

    constructor(initialValue: T, name: string, label: string, required: boolean, regex?: string, formatter?: string) {
        this.name = name
        this.label = label
        this.regex = regex
        this.required = required
        this.value = initialValue
        this.valid = !required
        this.touched = false
        this.formatter = formatter ? formatter : ''
    }
}


// WEBPACK FOOTER //
// ./src/typings/api-models/creditCheck/FieldModel.ts